import React from 'react';
import styled from 'styled-components';

const ProgressBarWrapper = styled.div`
  width: 100%;
  height: ${({ height }) => height}px;
  background-color: ${({ theme }) => theme.dark70};
  border-radius: 4px;
  overflow: hidden;
  margin-top: ${({ marginTop }) => marginTop}px;
  margin-bottom: ${({ marginBottom }) => marginBottom}px;
  margin-left: ${({ marginLeft }) => marginLeft}px;
  margin-right: ${({ marginRight }) => marginRight}px;
`;

const ProgressBarFill = styled.div`
  width: ${({ percentage }) => percentage}%;
  height: 100%;
  background-color: ${({ theme }) => theme.primary};
  transition: width 0.5s ease;
`;

const StyledInputProgressBar = ({
  percentage,
  height = 5,
  marginTop = 15,
  marginBottom = 15,
  marginLeft = 0,
  marginRight = 0,
}) => {
  return (
    <ProgressBarWrapper
      height={height}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
    >
      <ProgressBarFill percentage={percentage} />
    </ProgressBarWrapper>
  );
};

export default StyledInputProgressBar;
